
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Welcome from './pages/Welcome';
import Login from './pages/Login'; // Импортируем Login
import Protected from './pages/Protected';
import OnlinePay from './pages/OnlinePay';
import SearchOrder from './pages/SearchOrder';
import Transactoins from './pages/Transactoins';
import Acc from './pages/Acc';
import PayWidget from './pages/PayWidget';
import OrderBookFX from './pages/OrderBookFX';

const App = () => {
  return (
    <Router>
      <Routes>

        <Route path="/login" element={<Welcome />} /> {/* Стартовая страница */}

        <Route path="/entry" element={<Login />} /> {/* Страница входа */}

        <Route path="/protected" element={<Protected />} /> {/* Защищённая страница */}

        <Route path="/" element={<SearchOrder />} /> {/* Страница поиска по номеру заказа*/}

        <Route path="/:orderNumber" element={<SearchOrder />} /> {/* ? orderNumber */}

        <Route path="/trn" element={<Transactoins />} /> {/* Страница поиска по номеру заказа*/}

        <Route path="/acc" element={<Acc />} /> {/* Страница поиска по номеру заказа*/}

        <Route path="/onlinepay" element={<OnlinePay />} /> {/* Страница ввода данных платёжной карты*/}

        <Route path="/pay" element={<PayWidget />} /> {/* Страница PayWidget*/}

        <Route path="/fx" element={<OrderBookFX />} /> {/* Страница стакана Kraken*/}

        <Route path="*" element={<Navigate to="/" />} /> {/* Редирект для несуществующих маршрутов */}

      </Routes>
    </Router>
  );
};

export default App;
